import axios from 'axios'

// Configure axios base URL
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000'
axios.defaults.baseURL = API_URL

// Request interceptor to add auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // if (error.response?.status === 401) {
    //   // Handle unauthorized access
    //   localStorage.removeItem('token')
    //   window.location.href = '/login'
    // }
    return Promise.reject(error)
  }
)

// API service functions
export const apiService = {
  // Products
  async getProducts(params = {}) {
    try {
      const response = await axios.get('/api/products', { params })
      return response.data
    } catch (error) {
      console.error('Error fetching products:', error)
      throw error
    }
  },

  async getProduct(id) {
    try {
      const response = await axios.get(`/api/products/${id}`)
      return response.data
    } catch (error) {
      console.error('Error fetching product:', error)
      throw error
    }
  },

  async createProduct(productData) {
    try {
      const response = await axios.post('/api/products', productData)
      return response.data
    } catch (error) {
      console.error('Error creating product:', error)
      throw error
    }
  },

  async updateProduct(id, productData) {
    try {
      const response = await axios.put(`/api/products/${id}`, productData)
      return response.data
    } catch (error) {
      console.error('Error updating product:', error)
      throw error
    }
  },

  async deleteProduct(id) {
    try {
      const response = await axios.delete(`/api/products/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting product:', error)
      throw error
    }
  },

  async updateProductStatus(id, isActive) {
    try {
      const response = await axios.patch(`/api/products/${id}/status`, { isActive })
      return response.data
    } catch (error) {
      console.error('Error updating product status:', error)
      throw error
    }
  },

  async updateProductInventory(id, inventoryData) {
    try {
      const response = await axios.patch(`/api/products/${id}/inventory`, inventoryData)
      return response.data
    } catch (error) {
      console.error('Error updating product inventory:', error)
      throw error
    }
  },

  async getProductStats() {
    try {
      const response = await axios.get('/api/products/stats/overview')
      return response.data
    } catch (error) {
      console.error('Error fetching product stats:', error)
      throw error
    }
  },

  // Orders
  async createOrder(orderData) {
    try {
      const response = await axios.post('/api/orders', orderData)
      return response.data
    } catch (error) {
      console.error('Error creating order:', error)
      throw error
    }
  },

  async getOrders(params = {}) {
    try {
      const response = await axios.get('/api/orders', { params })
      return response.data
    } catch (error) {
      console.error('Error fetching orders:', error)
      throw error
    }
  },

  // Auth
  async login(credentials) {
    try {
      const response = await axios.post('/api/auth/login', credentials)
      return response.data
    } catch (error) {
      console.error('Error logging in:', error)
      throw error
    }
  },

  async register(userData) {
    try {
      const response = await axios.post('/api/auth/register', userData)
      return response.data
    } catch (error) {
      console.error('Error registering:', error)
      throw error
    }
  },

  async getProfile() {
    try {
      const response = await axios.get('/api/auth/profile')
      return response.data
    } catch (error) {
      console.error('Error fetching profile:', error)
      throw error
    }
  },

  // Health check
  async healthCheck() {
    try {
      const response = await axios.get('/api/health')
      return response.data
    } catch (error) {
      console.error('Health check failed:', error)
      throw error
    }
  }
}

export default apiService 